import React from 'react';

import { Icon, Tooltip } from 'design-system-web';

import { useLabels } from '../../i18n/useLabels';
import type { BadgeViewModel } from '../../viewmodels/messages';

import styles from './Badge.scss';

type Props = {
  viewModel: BadgeViewModel;
};

const ICON_NAME_BY_KIND: Record<BadgeViewModel['kind'], string> = {
  lock: 'lock',
  hidden: 'eye-slash',
};

export function Badge({ viewModel }: Props) {
  const { formatMessage } = useLabels();
  const tooltip = formatMessage({ key: viewModel.tooltipKey });

  return (
    <Tooltip placement="top" TooltipComponent={tooltip}>
      <button
        type="button"
        aria-label={tooltip}
        data-test={`${viewModel.kind}-badge`}
        className={styles.badge}
      >
        <Icon name={ICON_NAME_BY_KIND[viewModel.kind]} />
      </button>
    </Tooltip>
  );
}
